(function(){
  'use strict';
  // V4.1 preview: Shopify-backed cards only when Klaviyo does not render a native product card.
  // Never reads order, account, or payment data. No synthetic Klaviyo product events.
  var root=document.getElementById('zv3-root'),index=document.getElementById('zv35-product-index');
  if(!root||!index||!index.content)return;
  var locale=(root.getAttribute('data-locale')||'en').slice(0,2).toLowerCase();
  var copy={
    da:{choose:'Vælg pakke',add:'Læg i kurv',added:'Lagt i kurv',cart:'Se kurv',sold:'Ikke på lager',error:'Kunne ikke lægge i kurv. Prøv igen.',view:'Se produkt',pack:'glas'},
    fr:{choose:'Choisir le lot',add:'Ajouter au panier',added:'Ajouté au panier',cart:'Voir le panier',sold:'Indisponible',error:"Impossible d’ajouter au panier. Réessayez.",view:'Voir le produit',pack:'verres'},
    it:{choose:'Scegli la confezione',add:'Aggiungi al carrello',added:'Aggiunto al carrello',cart:'Vedi carrello',sold:'Non disponibile',error:'Impossibile aggiungere. Riprova.',view:'Vedi prodotto',pack:'calici'},
    es:{choose:'Elegir lote',add:'Añadir al carrito',added:'Añadido',cart:'Ver carrito',sold:'Agotado',error:'No se pudo añadir. Inténtalo de nuevo.',view:'Ver producto',pack:'copas'},
    nl:{choose:'Kies set',add:'In winkelwagen',added:'Toegevoegd',cart:'Bekijk winkelwagen',sold:'Uitverkocht',error:'Toevoegen mislukt. Probeer opnieuw.',view:'Bekijk product',pack:'glazen'},
    de:{choose:'Set auswählen',add:'In den Warenkorb',added:'Hinzugefügt',cart:'Warenkorb ansehen',sold:'Nicht verfügbar',error:'Hinzufügen fehlgeschlagen. Erneut versuchen.',view:'Produkt ansehen',pack:'Gläser'},
    fi:{choose:'Valitse pakkaus',add:'Lisää ostoskoriin',added:'Lisätty koriin',cart:'Näytä ostoskori',sold:'Loppuunmyyty',error:'Lisääminen epäonnistui. Yritä uudelleen.',view:'Näytä tuote',pack:'lasia'},
    en:{choose:'Choose a pack',add:'Add to cart',added:'Added to cart',cart:'View cart',sold:'Sold out',error:'Could not add to cart. Please retry.',view:'View product',pack:'glasses'}
  };
  var t=copy[locale]||copy.en, products=Object.create(null);
  index.content.querySelectorAll('[data-handle]').forEach(function(el){
    var variants=[];
    el.querySelectorAll('[data-variant-id]').forEach(function(v){
      var id=v.getAttribute('data-variant-id');
      if(!/^\d+$/.test(id||''))return;
      variants.push({id:id,title:v.getAttribute('data-variant-title')||'',price:v.getAttribute('data-price')||'',available:v.getAttribute('data-available')==='true'});
    });
    if(variants.length)products[el.getAttribute('data-handle')]={
      title:el.getAttribute('data-title')||'',image:el.getAttribute('data-image')||'',url:el.getAttribute('data-url')||'',variants:variants
    };
  });
  var allowed=/^(?:zaltify\.com|www\.zaltify\.com|(?:dk|fr|it|es|nl|de|fi|eu)\.zaltify\.com|cvadhx-sd\.myshopify\.com)$/i;
  function productUrl(product,handle,variantId){
    var url;
    try{url=new URL(product.url,location.origin);}catch(e){return null;}
    if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\//.test(url.pathname))return null;
    if(variantId)url.searchParams.set('variant',variantId);
    url.searchParams.set('utm_source','customer_agent');
    url.searchParams.set('utm_medium','chat');
    url.searchParams.set('utm_campaign','zaltify_glasraadgiver');
    url.searchParams.set('utm_content','product_'+handle.replace(/^zalto-/,'').replace(/[^a-z0-9_-]/g,'_'));
    return url.toString();
  }
  function variantLabel(v){
    var match=v.title.match(/^(\d+)\s*[- ]?\s*pack$/i);
    return match?match[1]+' '+t.pack:v.title;
  }
  function createCard(handle,source){
    var product=products[handle];if(!product||!source.isConnected)return;
    if(source.closest('.kl-hub-card,.zv41-shop-card,.zv36-recommendations,.zv36-card,.zv36-rail'))return;
    var url=productUrl(product,handle);if(!url)return;
    var box=document.createElement('section');box.className='zv41-shop-card';box.dataset.zv41Handle=handle;
    box.setAttribute('aria-label',product.title);
    var top=document.createElement('div');top.className='zv41-shop-top';
    if(product.image){var img=document.createElement('img');img.src=product.image;img.alt='';img.loading='lazy';img.width=76;img.height=95;top.appendChild(img);}
    var description=document.createElement('div');description.className='zv41-shop-description';
    var link=document.createElement('a');link.textContent=product.title;link.href=url;link.className='zv41-shop-product';
    description.appendChild(link);
    var price=document.createElement('div');price.className='zv41-shop-price';description.appendChild(price);
    top.appendChild(description);box.appendChild(top);
    var label=document.createElement('label');label.className='zv41-shop-label';label.textContent=t.choose;
    var select=document.createElement('select');select.className='zv41-shop-select';
    product.variants.forEach(function(v){
      var option=document.createElement('option');option.value=v.id;option.textContent=variantLabel(v)+(v.available?'':' - '+t.sold);
      option.disabled=!v.available;select.appendChild(option);
    });
    var preferred=product.variants.find(function(v){return v.available;})||product.variants[0];
    var oldLink;
    try{oldLink=new URL(source.href,location.origin).searchParams.get('variant');}catch(e){}
    var exact=product.variants.find(function(v){return v.id===oldLink&&v.available;});
    select.value=(exact||preferred).id;
    label.appendChild(select);box.appendChild(label);
    var button=document.createElement('button');button.type='button';button.className='zv41-shop-add';box.appendChild(button);
    var foot=document.createElement('div');foot.className='zv41-shop-foot';box.appendChild(foot);
    function refresh(){
      var chosen=product.variants.find(function(v){return v.id===select.value;})||preferred;
      price.textContent=chosen.price;
      button.disabled=!chosen.available;
      button.textContent=chosen.available?t.add:t.sold;
      link.href=productUrl(product,handle,chosen.id)||url;
      foot.textContent='';
    }
    select.addEventListener('change',refresh);refresh();
    button.addEventListener('click',async function(event){
      event.preventDefault();
      event.stopPropagation();
      var chosen=product.variants.find(function(v){return v.id===select.value;});
      if(!chosen||!chosen.available||button.disabled)return;
      var rootPath=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      if(rootPath.charAt(rootPath.length-1)!=='/')rootPath+='/';
      // Use the visitor's Shopify session, currency and currently selected Market.
      var endpoint=function(name){return rootPath+name;};
      var readCart=async function(){
        var response=await fetch(endpoint('cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'},cache:'no-store'});
        if(!response.ok)throw new Error('Unable to verify Shopify cart');
        return response.json();
      };
      var quantityFor=function(cart){
        return (cart.items||[]).filter(function(item){return String(item.variant_id||item.id)===chosen.id;})
          .reduce(function(total,item){return total+Number(item.quantity||0);},0);
      };
      var viewCart=function(){
        foot.textContent='';
        var cart=document.createElement('a');cart.href=endpoint('cart');cart.className='zv41-shop-cart';cart.textContent=t.cart+' →';
        foot.appendChild(cart);
      };
      var confirmedAdd=false,after=null,body=null;
      button.disabled=true;button.textContent='…';foot.textContent='';
      try{
        // First read the cart so success cannot be claimed on an unchanged basket.
        var before=await readCart();
        var sectionIds=Array.from(new Set(Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map(function(node){return node.dataset.sectionId;}).filter(Boolean))).slice(0,5);
        body={items:[{id:Number(chosen.id),quantity:1}],sections:sectionIds,sections_url:location.pathname};
        var response=await fetch(endpoint('cart/add.js'),{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(body)
        });
        var payload=await response.json();
        if(!response.ok||payload.status>=400)throw new Error(payload.description||payload.message||('Shopify '+response.status));
        confirmedAdd=true;
        after=await readCart();
        if(quantityFor(after)<quantityFor(before)+1){
          // Only re-read; never retry the POST, to prevent accidental duplicate additions.
          await new Promise(function(resolve){setTimeout(resolve,250);});
          after=await readCart();
        }
        if(quantityFor(after)<quantityFor(before)+1)throw new Error('Cart response not yet verified');
        button.textContent=t.added;
        viewCart();
        if(window.zaltifyChatMetrics)window.zaltifyChatMetrics.emit('Zaltify Chat Add To Cart Confirmed',{product_handle:handle,variant_id:chosen.id,quantity:1,origin:'chat_product_card'});
        // Horizon's cart components REQUIRE detail.data.sections and itemCount.
        // This matches the event contract already used by Zaltify's cart upsell.
        document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{
          resource:after,sourceId:'zaltify-chat-card',
          data:{source:'zaltify-chat',variantId:chosen.id,itemCount:after.item_count,sections:payload.sections||{}}
        }}));
        button.disabled=false;
      }catch(error){
        console.warn('[Zaltify Glass Advisor] Cart add issue',error);
        if(confirmedAdd){
          // Shopify accepted the POST but follow-up verification was unavailable:
          // do not encourage a second click which may add duplicates.
          button.textContent=t.cart;
          button.disabled=true;
          viewCart();
        }else{
          button.textContent=t.add;
          button.disabled=false;
          foot.textContent=(error&&error.message)||t.error;
        }
      }
    });
    var attach=source.closest('p,li')||source;
    if(attach.parentNode){attach.parentNode.insertBefore(box,attach.nextSibling);if(window.zaltifyChatMetrics)window.zaltifyChatMetrics.emit('Zaltify Chat Product Card Displayed',{product_handle:handle,origin:'verified_fallback_card'});}
    source.dataset.zv41Card='1';
    var chat=source.closest('.kl-hub-route-chat');if(chat)hideNativeDuplicates(chat);
    return box;
  }
  var scheduled=false;
  // Some custom Klaviyo skills return model names but no product URL/card.
  // When model names are clearly emphasized in a message, show verified Shopify
  // products from the current storefront. Never synthesize prices or order status.
  function hideNativeDuplicates(chat){
    var own=Array.from(chat.querySelectorAll('.zv41-shop-card[data-zv41-handle]'));
    if(!own.length)return;
    var handles=new Set(own.map(function(n){return n.dataset.zv41Handle;}));
    chat.querySelectorAll('.kl-hub-card').forEach(function(card){
      if(card.closest('.zv41-shop-card')||card.dataset.zv41NativeHidden==='1')return;
      // Never hide customer order cards, which have a "View order" action.
      var add=Array.from(card.querySelectorAll('button,[role="button"]')).some(function(b){
        return /læg i kurv|læg i indkøbskurven|add to cart|ajouter au panier|aggiungi al carrello|añadir al carrito|in winkelwagen|in den warenkorb|lisää ostoskoriin/i.test(b.textContent||'');
      });
      if(!add)return;
      var links=Array.from(card.querySelectorAll('a[href*="/products/"]'));
      var matches=links.some(function(a){
        try { var u=new URL(a.getAttribute('href'),location.href);
          var m=u.pathname.match(/\/products\/([^/?#]+)/);
          return m&&handles.has(m[1]);
        } catch(e){return false;}
      });
      // Some built-in Klaviyo product cards have no product-page link.
      if(!matches){
        var contents=(card.textContent||'').toLowerCase();
        handles.forEach(function(h){
          if(matches)return;
          var model=h.replace(/^zalto-/,'').replace(/-glass$/,'').replace(/-/g,' ');
          var options=[model];
          if(model==='burgundy')options.push('bourgogne','borgogna','borgoña','burgunder');
          if(model==='bordeaux')options.push('burdeos');
          if(contents.includes('zalto')&&options.some(function(name){return contents.includes(name);}))matches=true;
        });
      }
      if(matches){card.hidden=true;card.style.display='none';card.dataset.zv41NativeHidden='1';}
    });
  }

  // Normalize Klaviyo's native product cards into the same first-party Shopify
  // variant card used for text/link recommendations. Order cards never qualify.
  function nativeHandle(card){
    var buttons=Array.from(card.querySelectorAll('button,[role="button"]'));
    var action=/læg i kurv|læg i indkøbskurven|add to cart|ajouter au panier|aggiungi al carrello|añadir al carrito|in winkelwagen|in den warenkorb|lisää ostoskoriin/i;
    if(!buttons.some(function(node){return action.test(node.textContent||'');}))return null;
    var links=Array.from(card.querySelectorAll('a[href*="/products/"]'));
    for(var i=0;i<links.length;i++){
      try {
        var u=new URL(links[i].getAttribute('href'),location.origin);
        var m=u.pathname.match(/\/products\/([^/?#]+)/);
        if(m&&products[m[1]])return m[1];
      }catch(e){}
    }
    var text=(card.textContent||'').toLowerCase();
    if(!/zalto/i.test(text))return null;
    var normalized=text.normalize('NFD').replace(/[\u0300-\u036f]/g,'');
    var aliases=[
      ['zalto-universal-glass',/\buniversal\b/],
      ['zalto-burgundy-glass',/\b(?:bourgogne|burgundy|borgogna|borgona|burgunder|burgundin)\b/],
      ['zalto-bordeaux-glass',/\b(?:bordeaux|burdeos)\b/],
      ['zalto-white-wine-glass',/(?:vin\s+blanc|vins\s+blancs|hvidvins?|white\s+wine|vino\s+bianco|vino\s+blanco|wei(?:ss|ß)wein|valkoviini|witte\s+wijn)/],
      ['zalto-champagne-glass',/(?:champagne|sampanja|champan|champagner|champagnel)/],
      ['zalto-balance-glass',/\bbalance\b/],
      ['zalto-gravitas-omega',/\bgravitas\b/],
      ['zalto-mystique',/\bmystique\b/],
      ['zalto-coupe-crystal-clear',/\bcoupe\s+crystal\b/],
      ['zalto-coupe-effect',/\bcoupe\s+effect\b/],
      ['zalto-water-glass',/\b(?:water|vandglas|wasserglas|verre a eau)\b/],
      ['zalto-beer-glass',/\b(?:beer|olglas|bierglas|birra)\b/]
    ];
    for(var k=0;k<aliases.length;k++)if(products[aliases[k][0]]&&aliases[k][1].test(normalized))return aliases[k][0];
    var names=[
      ['zalto-universal-glass',/zalto\s+universal/],
      ['zalto-burgundy-glass',/zalto\s+(?:bourgogne|burgundy|borgogna|borgoña|burgunder|burgundin)/],
      ['zalto-bordeaux-glass',/zalto\s+(?:bordeaux|burdeos)/],
      ['zalto-white-wine-glass',/zalto\s+(?:hvidvin|white wine|vin blanc|vino bianco|vino blanco|weisswein|weißwein|valkoviini)/],
      ['zalto-champagne-glass',/zalto\s+(?:champagne|sampanja|champán|champagner)/],
      ['zalto-balance-glass',/zalto\s+balance/],
      ['zalto-gravitas-omega',/zalto\s+gravitas/],
      ['zalto-coupe-crystal-clear',/zalto\s+coupe\s+crystal/],
      ['zalto-coupe-effect',/zalto\s+coupe\s+effect/],
      ['zalto-mystique',/zalto\s+mystique/],
      ['zalto-water-glass',/zalto\s+(?:water|vandglas|wasserglas)/],
      ['zalto-beer-glass',/zalto\s+(?:beer|ølglas|bierglas)/]
    ];
    for(var j=0;j<names.length;j++)if(products[names[j][0]]&&names[j][1].test(text))return names[j][0];
    return null;
  }
  function normalizeNativeCards(chat){
    chat.querySelectorAll('.kl-hub-card:not([data-zv41-native-processed])').forEach(function(card){
      if(card.closest('.zv41-shop-card'))return;
      var handle=nativeHandle(card);
      if(!handle)return;
      card.dataset.zv41NativeProcessed='1';
      // If an equivalent Shopify card is already present in this same reply,
      // hide only the redundant native card. Do not duplicate a working card.
      var reply=card.closest('.kl-hub-message,.kl-hub-chat-message,[data-message-id]');
      var same=reply&&Array.from(reply.querySelectorAll('.zv41-shop-card[data-zv41-handle]'))
        .some(function(node){return node.dataset.zv41Handle===handle;});
      if(same){
        card.hidden=true;card.style.display='none';
        card.dataset.zv41NativeHidden='1';
        return;
      }
      // Use a sibling anchor so the Shopify card is outside Klaviyo's native
      // product card and can use its real market variants and AJAX cart flow.
      var anchor=document.createElement('span');
      anchor.hidden=true;
      anchor.className='zv41-native-anchor';
      card.insertAdjacentElement('afterend',anchor);
      try{
        var added=createCard(handle,anchor);
        if(added&&added.isConnected&&added.classList.contains('zv41-shop-card')){
          card.hidden=true;
          card.style.display='none';
          card.dataset.zv41NativeHidden='1';
        }else{
          card.removeAttribute('data-zv41-native-processed');
        }
      }catch(e){
        card.removeAttribute('data-zv41-native-processed');
      }
      anchor.remove();
    });
  }
  function textOnlyFallback(chat){
    chat.querySelectorAll('.kl-hub-message').forEach(function(bubble){
      if(bubble.dataset.zv41TextCards||bubble.querySelector('.kl-hub-card,.zv41-shop-card'))return;
      if(bubble.querySelector('a[href*="/products/"]'))return; // Explicit links get handled first.
      var seen=Object.create(null),handles=[];
      bubble.querySelectorAll('strong,b').forEach(function(node){
        var content=(node.textContent||'').trim().toLowerCase(),h='';
        if(/zalto[^a-z]{0,3}universal/.test(content))h='zalto-universal-glass';
        else if(/zalto[^a-z]{0,3}(?:bourgogne|burgundy|borgogna|borgoña|burgunder|burgundin)/.test(content))h='zalto-burgundy-glass';
        else if(/zalto[^a-z]{0,3}(?:bordeaux|burdeos)/.test(content))h='zalto-bordeaux-glass';
        else if(/zalto[^a-z]{0,3}balance/.test(content))h='zalto-balance-glass';
        else if(/zalto[^a-z]{0,3}champagne/.test(content))h='zalto-champagne-glass';
        else if(/zalto[^a-z]{0,3}gravitas/.test(content))h='zalto-gravitas-omega';
        else if(/zalto[^a-z]{0,3}(?:white wine|hvidvin|vin blanc|vino blanco|vino bianco)/.test(content))h='zalto-white-wine-glass';
        if(h&&products[h]&&!seen[h]){seen[h]=true;handles.push(h);}
      });
      if(!handles.length)return;
      bubble.dataset.zv41TextCards='pending';
      setTimeout(function(){
        if(!bubble.isConnected||bubble.querySelector('.kl-hub-card'))return;
        if(bubble.querySelector('a[href*="/products/"]'))return;
        // Reverse so inserting after the same paragraph preserves recommendation order.
        handles.slice(0,3).reverse().forEach(function(h){
          var source=bubble.querySelector('strong,b')||bubble;
          try{createCard(h,source);}catch(e){}
        });
        bubble.dataset.zv41TextCards='done';
      },1100);
    });
  }
  function enhance(chat){
    var anchors=chat.querySelectorAll('a[href]:not([data-zv41-card])');
    anchors.forEach(function(a){
      if(a.closest('.kl-hub-card,.zv41-shop-card,.zv36-recommendations,.zv36-card,.zv36-rail,.kl-hub-chat-input-wrapper'))return;
      var url;try{url=new URL(a.getAttribute('href'),location.href);}catch(e){return;}
      if(!allowed.test(url.hostname))return;
      var hit=url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^/?#]+)\/?$/i);
      if(!hit||!products[hit[1]])return;
      a.dataset.zv41Card='pending';
      setTimeout(function(){
        if(!a.isConnected||!a.closest('.kl-hub-route-chat'))return;
        var parent=a.closest('.kl-hub-chat-message,.kl-hub-message,[data-message-id],[data-role]');
        // Prefer verified Shopify variant card even when a native Klaviyo product card exists.
        try{createCard(hit[1],a);}catch(e){a.dataset.zv41Card='error';}
      },700);
    });
    normalizeNativeCards(chat);
    textOnlyFallback(chat);
    hideNativeDuplicates(chat);
  }
  function attach(chat){
    if(chat.dataset.zv41CardsBound)return;
    chat.dataset.zv41CardsBound='1';
    var observer=new MutationObserver(function(){
      if(!chat.isConnected)return;
      // Klaviyo progressively hydrates product cards. Replace recognizable
      // cards before paint, even when only an existing text node changed.
      normalizeNativeCards(chat);
      if(scheduled)return;scheduled=true;
      requestAnimationFrame(function(){scheduled=false;if(chat.isConnected)enhance(chat);});
    });
    observer.observe(chat,{childList:true,subtree:true,characterData:true});
    enhance(chat);
  }
  setInterval(function(){
    document.querySelectorAll('.kl-hub-route-chat').forEach(function(chat){
      attach(chat);
      if(chat.isConnected)enhance(chat);
    });
  },650);
  document.querySelectorAll('.kl-hub-route-chat').forEach(attach);
})();